module.exports = __webpack_public_path__ + "static/media/fhs-store-locator-active.d3b55dec.png";